module.exports = __webpack_public_path__ + "assets/img/hourglass.85f73e2c.svg";